import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { PhoneCountryCodeType } from '@bus/models';
import { getEnumValues } from '../../../services/common/miscUtils';
import Yup, {
  maxMobileNumberLength,
  minMobileNumberLength,
  regExEmail,
  regexVat,
} from '../../../services/common/validation';
import { CorrespondenceMethodEnum, NoYesEnum } from '../../../types/forms';
import { TradingDetailsServicePlanFormModelNew } from './formModel';

export const createTradingDetailsServicePlanFormValidator = (): ObjectSchema<TradingDetailsServicePlanFormModelNew> => {
  return Yup.object({
    legalName: Yup.string().requiredWithMsg(),
    vatLiable: Yup.string().requiredWithMsg().oneOf(getEnumValues(NoYesEnum)),
    tradingAs: Yup.string().requiredWithMsg(),
    vatNumber: Yup.string().when('vatLiable', {
      is: (vatLiable: NoYesEnum) => vatLiable === NoYesEnum.yes,
      then: (schema) =>
        schema
          .matches(regexVat, { message: t('validation:invalidVat') })
          .lengthBetween(0, 10)
          .requiredWithMsg(),
      otherwise: (schema) =>
        schema
          .optional()
          .matches(regexVat, { message: t('validation:invalidVat') })
          .lengthBetween(0, 10),
    }),
    email: Yup.string().required(t('validation:required')).matches(regExEmail, t('validation:invalidEmail')),
    mobileNumber: Yup.string().requiredWithMsg().lengthBetween(minMobileNumberLength, maxMobileNumberLength),
    countryCode: Yup.string().requiredWithMsg().oneOf(getEnumValues(PhoneCountryCodeType)),
    correspondenceMethod: Yup.string()
      .required(t('validation:required'))
      .oneOf(getEnumValues(CorrespondenceMethodEnum)),
  });
};
